import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReopenParams } from "../../../domain/entities/undelivered";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reopen = createAsyncThunk<
  void,
  ReopenParams,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REOPEN, async (params, { extra }) => {
  await extra.undeliveredRepo.reopen(params);
});
